export const getSubdomain = () => {
  const account = JSON.parse(localStorage.getItem('account'));
  if (account && account.token) {
    return account.token.split(':')[0];
  }
};